module.exports = "/_next/static/images/ico_spr.66pUW1wQ.png";